export type IAccountSettingsResources = typeof AccountSettingsResources;

export const AccountSettingsResources = {
    changePassword: "Zmień hasło",
    changeEmailAddress: "Zmień adres e-mail",
    changeEmailSuccessDescription:
        "Link weryfikacyjny został wysłany na wskazany adres e-mail. Będzie aktywny przez następne 24h. Jeśli nie zweryfikujesz adresu e-mail zmiana nie zostanie zapisana.",
    changeEmailSuccessHeader: "Sprawdź skrzynkę!",
    saveChanges: "Zapisz zmiany",
    verifyEmailAddress: "Zweryfikuj adres e-mail",

    birthDateLabel: "Data urodzenia",
    birthDatePlaceholder: "DD.MM.RRRR",
};
